export const isEphemeralSocialAvatar = (url?: string) =>
  !!url?.trim() && /cdninstagram\.com|fbcdn\.net/i.test(url.trim());

export const pickBetterAvatar = (existing?: string, incoming?: string) => {
  const current = existing?.trim();
  const next = incoming?.trim();
  if (!next) return current;
  if (!current) return next;
  if (isEphemeralSocialAvatar(current) && !isEphemeralSocialAvatar(next)) {
    return next;
  }
  if (!isEphemeralSocialAvatar(current) && isEphemeralSocialAvatar(next)) {
    return current;
  }
  return current;
};

export const pickBestAvatar = (...candidates: Array<string | undefined>) =>
  candidates.reduce<string | undefined>(
    (best, candidate) => pickBetterAvatar(best, candidate),
    undefined
  );
